// extracted by mini-css-extract-plugin
module.exports = {"desc":"desc--2t4Q7"};